const groupByIdForm = {
    'PMD_1': [{ id: 'PMD_1', name: 'Серцево-судинні та цереброваскулярні захворювання, цукровий діабет 2-го типу та хронічні хвороби нижніх дихальних шляхів. Імуносупресивні лікарські засоби.'}],
    'INSULIN_1': [{ id: 'INSULIN_1', name: 'Інсуліни' }],
    'ND_1': [{ id: 'ND_1', name: 'Нецукровий діабет' }],
    'PSYCHIATRY': [{ id: 'PSYCHIATRY', name: 'Розлади психіки та поведінки. Епілепсія. Хвороба Паркінсона.' }],
    'GENERAL': [
            { id: 'PMD_1', name: 'Серцево-судинні та цереброваскулярні захворювання, цукровий діабет 2-го типу та хронічні хвороби нижніх дихальних шляхів. Імуносупресивні лікарські засоби.'},
            { id: 'INSULIN_1', name: 'Інсуліни' },
            { id: 'ND_1', name: 'Нецукровий діабет' },
            { id: 'PSYCHIATRY', name: 'Розлади психіки та поведінки. Епілепсія. Хвороба Паркінсона.' },
            { id: 'GENERAL', name: 'Договір з реімбурсації' }
        ]
};

export default groupByIdForm;